import Message from "../../message";
import {useMainStore} from "@/store";

export default class ApplicationRejected extends Message
{
    handle()
    {
        useMainStore().REMOVE_APPLICATION(this.message.guild_id);
    }
}
